import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function DobStep({ profile, saveField }) {
  return (
    <div className="space-y-3">
      <div>
        <Label htmlFor="ob-dob">Date of birth</Label>
        <Input
          id="ob-dob" type="date" className="mt-1.5"
          value={profile.date_of_birth || ""}
          onChange={(e) => saveField({ date_of_birth: e.target.value || null })}
          data-testid="onboarding-dob"
        />
      </div>
      <div className="text-xs text-muted-foreground">
        We use your age only to reason about life stage, risk tolerance, and retirement timing.
        It&apos;s never shown on your public profile.
      </div>
    </div>
  );
}
